import Vue from 'vue';
import moment from 'moment';

export default data => Vue.$http
  .post('Orders/print', data, {
    responseType: 'arraybuffer',
  })
  .then((response) => {
    const headers = response.headers;
    const blob = new Blob([response.data], {
      type: headers['content-type'],
    });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = `order_${data.order.orderNum}_${moment().format('hhmmsssss')}`;
    link.click();
  });



// WEBPACK FOOTER //
// ./src/services/order/print.js